import React, { createContext, useState, useContext, useEffect, useRef } from 'react';
import { useNotification } from './NotificationContext'; 
import { useTranslation } from 'react-i18next'; // Importing translation hook
import { useAppData } from "../hooks/useAppData";
import { useAppStore } from "../hooks/useAppStore";

//import * as Data from '../data'; // Import all constants
import axios from 'axios'; // Ensure axios is installed for HTTP requests

const DataContext = createContext({});

export const DataProvider = ({ children }) => {
  const { t } = useTranslation(); // Hook to access translation
  const { showNotification } = useNotification();

  /*const [wordListId, setWordListId] = useState(() => {
    // Load word list from session storage at initialization
    const savedWordListId = sessionStorage.getItem('wordListId');
    return savedWordListId ? JSON.parse(savedWordListId) : [];
  });  

  // Your word list data and other state logic go here
  const [wordList, setWordList] = useState(() => {
    // Load word list from session storage at initialization
    const savedWordList = sessionStorage.getItem('wordList');
    return savedWordList ? JSON.parse(savedWordList) : [];
  });  */

  const { 
      wordList, 
      isWordListPending,
      isWordListError, 
      wordListRefetch,
      updateWordList,
      updateWordListOnReorder,
      addGroup,
      deleteGroup,
      addWordItem,
      deleteWord,
      soundboard,
      shapes,
      isSoundboardPending,
      isSoundboardError, 
      soundboardRefetch,
      addShape,
      updateShape,
      updateButton,
      unassignButton,
      deleteShape,
      handleOptionChange,
      handleAssignedWordTooltipVisibility,
      assignedWordTooltipVisibility
    } = useAppData();
    
    const { 
      baseURL,
      wordListId, setWordListId, 
      soundboardId, setSoundboardId,
      stageWidth, setStageWidth,
      stageHeight, setStageHeight,
      buttonPopovers, setButtonPopovers,
      shapePopovers, setShapePopovers,
      selectedItem, setSelectedItem,
      wordListWidth, setWordListWidth
    } = useAppStore();



  /*const [soundboardId, setSoundboardId] = useState(() => {
    // Load word list from session storage at initialization
    const savedSoundboardId = sessionStorage.getItem('soundboardId');
    return savedSoundboardId ? JSON.parse(savedSoundboardId) : [];
  });  */
  //const [shapes, setShapes] = useState([]);
  /*const [wordListWidth, setWordListWidth] = useState([]);
  const [stageWidth, setStageWidth] = useState(0); 
  const [stageHeight, setStageHeight] = useState(window.innerHeight);

  const [buttonPopovers, setButtonPopovers] = useState(() => {
    const savedButtonPopovers = sessionStorage.getItem('buttonPopovers');
    return savedButtonPopovers ? JSON.parse(savedButtonPopovers) : generateButtonPopoversFromWordList(wordList);
  });

  const [shapePopovers, setShapePopovers] = useState({});

  const [selectedItem, setSelectedItem] = useState({ type: null, id: null });
  
  const [assignedWordTooltipVisibility, setAssignedWordTooltipVisibility] = useState(() => {
    const savedVisibility = sessionStorage.getItem('assignedWordTooltipVisibility');
    return savedVisibility ? JSON.parse(savedVisibility) : 'hover'; // default to 'hover' if not found
  }); // 'show', 'hide','hover'*/

 /* const colorOptions = [
    '#f44336', '#ff5722', '#e2851f', '#ff9800', '#ffeb3b', '#cddc39', '#617c08', '#4a7017',
    '#8bc34a', '#48e52e', '#2e8b57', '#4caf50', '#3faa68', '#00fcaa', '#009688', '#00bcd4',
    '#33b5de', '#03a9f4', '#2196f3', '#3f51b5', '#786ed6', '#5e3ff5', '#673ab7', '#a168f4',
    '#9c27b0', '#d93385', '#e91e63', '#ff0000', '#ff6d00', '#ffda00', '#b6ff00', '#00ff24',
    '#0091ff', '#47321F', '#707070', '#000000' 
  ];*/

  // Function to update shapes in frontend (Different than 'updateShape')
  //const updateShapes = (newShapes) => setShapes(newShapes);

 /* const getWordList = async () => {
    try {
      const response = await axios.get(`${baseURL}/api/wordLists/${wordListId}/getWordList`);
      if (response.data && response.data.wordGroups) {
        setWordList(response.data.wordGroups); // Setting the wordGroups directly
      }

    } catch (error) {

      const extra = { 
        message: t('errors.snackbar.wordListNotRetrieved'),
        wordListId,
      };
      showNotification({
        notification: t('errors.snackbar.wordListNotRetrieved'),
        type: 'error',
        extra,
        error,
        isException: true,
        actions: [
          { label: 'Refresh', onClick: () => window.location.reload() },
        ],
      });
     
    }
  }*/

  /*  wordGroupid: If an action pertains to entire wordList, this can be '', but this is not implemented in backend and no action affects entire wordList
      wordId: If action is on wordGroup level, wordId is ''
      field: the field to be changed, allowed groupName, text, buttonLabel, color
      newValue: What the new value should be*/
  /*
  const updateWordList = async (wordGroupId, wordId, field, newValue) => {
    // Optimistically update the UI before making the server call
    const previousWordList = wordList; // Backup the current state

    // Optimistically update the UI
    const updatedWordList = wordList.map(group => {
      if (group._id === wordGroupId) {
        return {
          ...group, // Create a new group object
          wordItems: group.wordItems.map(wordItem =>
            wordItem._id === wordId ? { ...wordItem, [field]: newValue } : wordItem
          ) // Create a new wordItem object if it changes
        };
      }
      return { ...group };  // Return a new group object even if unchanged
    });
    // Update the UI with the new state optimistically
    setWordList([...updatedWordList]);  // Ensure a new array reference is passed

    try {
      const response = await axios.put(`${baseURL}/api/wordLists/wordList/${wordListId}`, { 
        wordGroupId: wordGroupId,
        wordId: wordId,
        field: field,
        newValue: newValue  // Make sure to send the actual value
      });

      if (response && response.data) {
        await getWordList();
      } else {
        throw new Error("Server response was not valid.");
      }
    } catch (error) {
      // If an error occurs, rollback to the previous state
      setWordList(previousWordList);

      const extra = { 
        message: 'Failed to update word list on server',
        wordListId, 
        wordGroupId,
        wordId,
        field,
        newValue,
      };

      showNotification({
        notification: t('errors.snackbar.wordListNotUpdated'),
        type: 'error',
        extra, 
        error,
        isException: true,
      });
    
    }
  };*/

  /*const updateWordListOnReorder = async (source, destination) => {
    try {
      const response = await axios.put(`${baseURL}/api/wordLists/wordList/${wordListId}/reorderItems`, { 
        source: source,
        destination: destination
      });

      if (response && response.data) {
        await getWordList();  // Refresh the list to reflect changes
      } else {
        throw new Error("Server response was not valid.");
      }
    } catch (error) {
    
      const extra = { 
        message: 'Failed to reorder word list on server',
        wordListId,
        source,    
        destination,  
      };

      showNotification({
        notification: t('errors.snackbar.wordListNotReordered'),
        type: 'error',
        extra, 
        error,
        isException: true,
      });
    }
  };*/

  /*const addGroup = async (groupName) => {
    try {
      const response = await axios.post(`${baseURL}/api/wordLists/wordList/${wordListId}/wordGroups`, { 
        groupName: groupName
      });

      //ec await getWordList();
      
    } catch (error) {
      const extra = { 
        message: 'Failed to add word group',
        wordListId,
        groupName,
      };

      showNotification({
        notification: t('errors.snackbar.wordListGroupNotAdded'),
        type: 'error',
        extra, 
        error,
        isException: true,
      });
      
    }
  }*/
  
  /*const deleteGroup = async (groupId) => {
    try {
      // Find words in the group
      const group = wordList.find(g => g._id === groupId);
      if (!group) {
          return;
      }

      const wordIds = group.wordItems.map(word => word._id);

      // Find all buttons assigned to those words
      const buttonsToUnassign = shapes
      .flatMap(shape =>
          shape.buttons
              .filter(button => wordIds.includes(button.wordId)) // Only get buttons assigned to deleted words
              .map(button => ({
                  ...button,
                  shapeId: shape._id,  // Add shapeId to each button
                  shapeColor: shape.color || '#d1d1d1' // Get shape color, fallback to default gray
              }))
      );

      buttonsToUnassign.forEach(button => {
      if (!button.shapeId) {
          showNotification({
              notification: t('errors.snackbar.missingShapeId'),
              type: 'error',
              isException: true,
          });
      }
      });

       // Unassign buttons
       await Promise.all(buttonsToUnassign.map(button => 
        updateButton(button._id, 'wordId', null)
      ));

      await Promise.all(buttonsToUnassign.map(button => 
          updateButton(button._id, 'buttonLabel', null)
      ));


      // Reset button color to the shape's color
      await Promise.all(buttonsToUnassign.map(button =>
          updateButton(button._id, 'color', null)
      ));

      await axios.delete(`${baseURL}/api/wordLists/${wordListId}/${groupId}`);

      //ec await getWordList();
      await getSoundboard();

    } catch (error) {

      const extra = { 
        message: 'Failed to delete group from server',
        wordListId,
        groupId
      };
      
      showNotification({
        notification: t('errors.snackbar.wordListGroupNotDeleted'),
        type: 'error',
        extra, 
        error,
        isException: true,
      });

    }
  };*/
  
  /*const addWordItem = async (wordGroupId, newWord) => {
    try {
      const response = await axios.post(`${baseURL}/api/wordLists/wordList/${wordListId}/wordGroups/${wordGroupId}/addWordItem`, { 
        newWordItemText: newWord
      });

      //ec await getWordList();
      
    } catch (error) {
      const extra = { 
        message: 'Failed to add word on server',
        wordListId,
        wordGroupId,
        newWord
      };

      showNotification({
        notification: t('errors.snackbar.wordListWordNotAdded'),
        type: 'error',
        extra, 
        error,
        isException: true,
      });
      
    }
  }*/

  /*const deleteWord = async (wordGroupId, wordId) => {
    try {
      //await axios.delete(`${baseURL}/api/wordLists/${wordListId}/${wordId}`);
      await axios.delete(`${baseURL}/api/wordLists/${wordListId}/${wordGroupId}/${wordId}`);
      
      //ec await getWordList();

    } catch (error) {
      const extra = { 
        message: 'Failed to delete word from server',
        wordListId,
        wordGroupId,
        wordId
      };

      showNotification({
        notification: t('errors.snackbar.wordListWordNotDeleted'),
        type: 'error',
        error,
        extra, 
        isException: true,
      });
      
    }
  };*/
  
  /*const getSoundboard = async () => {
    try {
      const response = await axios.get(`${baseURL}/api/soundboards/soundboard/${soundboardId}`);
      //setShapes(response.data.shapes);

      // Ensure we don't re-add deleted shapes
      setShapes(response.data.shapes.filter(shape => !pendingDeletions.has(shape._id)));

    } catch (error) {

      const extra = { 
        message: 'Failed to get soundboard from server',
        soundboardId
      };

      showNotification({
        notification: t('errors.snackbar.wordListWordNotDeleted'),
        type: 'error',
        extra, 
        error,
        isException: true,
      });
      
    }
  };*/

  /*const addShape = async (newShape) => {

    try {
      const response = await axios.post(`${baseURL}/api/soundboards/soundboard/${soundboardId}/shape`, newShape);
      //ec await getSoundboard();
      //updateShapes([...shapes, response.data]);  // Assuming the backend returns the newly added shape
    } catch (error) {
      const extra = { 
        message: 'Failed to add shape',
        soundboardId,
        newShape
      };

      showNotification({
        notification: t('errors.snackbar.SoundboardShapeNotAdded'),
        type: 'error',
        extra, 
        error,
        isException: true,
      });
      
    }
  };*/
  
  /*const updateShape = async (shapeId, field, value) => {

    // Find the original shape before making the optimistic update
    const originalShape = shapes.find((shape) => shape._id === shapeId);

    // Optimistically update the shape in local state
    setShapes((prevShapes) =>
      prevShapes.map((shape) =>
        shape._id === shapeId ? { ...shape, [field]: value } : shape
      )
    );

    try {
      const response = await axios.patch(`${baseURL}/api/soundboards/soundboard/${soundboardId}/shape/${shapeId}`, {
          field: field,
          value: value  // Make sure to send the actual value
      });

    } catch (error) {

      // Revert to the original shape if the update fails
      setShapes((prevShapes) =>
        prevShapes.map((shape) =>
          shape._id === shapeId ? originalShape : shape
        )
      );

      const extra = { 
        message: 'Error updating shape (front)',
        soundboardId,
        shapeId,
        field,
        value
      };
      
      showNotification({
        notification: t('errors.snackbar.SoundboardShapeNotUpdated'),
        type: 'error',
        extra, 
        error,
        isException: true,
      });
    }
  };*/

  /*const updateButton = async (buttonId, field, value) => {
    
    try {
      const response = await axios.patch(`${baseURL}/api/soundboards/soundboard/${soundboardId}/button/${buttonId}`, {
          field: field,
          value: value  // Make sure to send the actual value
      });
      if (response.status === 200) {
          //ec await getSoundboard();  
      }
    } catch (error) {

      const extra = { 
        message: 'Error updating button (front)',
        soundboardId,
        buttonId,
        field,
        value
      };

      showNotification({
        notification: t('errors.snackbar.SoundboardButtonNotUpdated'),
        type: 'error',
        extra, 
        error,
        isException: true,
      });

    }
  };*/

  const pendingDeletions = new Set(); // Keep track of deleted shape IDs

  /*const deleteShape = async (shapeId) => {
    // Find the shape by ID and extract button IDs
    const shape = shapes.find(s => s._id === shapeId);

    if (!shape) {
      const extra = { shapes, shapeId };  

      showNotification({
        notification: t('errors.snackbar.SoundboardShapeNotFound'),
        type: 'error',
        extra, 
        isException: false,
      });
    }

    pendingDeletions.add(shapeId); // Mark as pending deletion
    
    setShapes((prevShapes) => prevShapes.filter((shape) => shape._id !== shapeId));

    try {
      // Unassign button must be before delete shape, to find the buttons that are assigned first. Unassign buttons that have been assigned
      const buttonIds = shape.buttons.map(button => button._id);  // Assuming each button has an 'id' property
      await unassignButton(shapeId, buttonIds)
      
      await axios.delete(`${baseURL}/api/soundboards/soundboard/${soundboardId}/shape/${shapeId}`);

      //ec await getSoundboard();

    } catch (error) {
      pendingDeletions.delete(shapeId); // Remove from pending deletions on error

      const extra = { 
        message: 'Error deleting shape from soundboard',
        soundboardId,
        shapeId
      };

      showNotification({
        notification: t('errors.snackbar.SoundboardShapeNotDeleted'),
        type: 'error',
        extra, 
        error,
        isException: true,
      }); 
       // Revert deletion if it failed
       setShapes(prevShapes => [...prevShapes, shape]);
    }
    pendingDeletions.delete(shapeId);
  };*/

  /*function getRandomColor() {
    const randomIndex = Math.floor(Math.random() * colorOptions.length);
    return colorOptions[randomIndex];
  }*/

  /*const calculateNextButtonLabel = () => {
    // Extract all button labels from all shapes' buttons
    const assignedLabels = shapes
      .flatMap(shape => shape.buttons.map(button => button.buttonLabel))
      .filter(Boolean)
      .map(label => Number(label)) // Ensure labels are numbers
      .sort((a, b) => a - b);
  
    // Find the lowest available label
    let nextLabel = 1;
    for (let i = 0; i < assignedLabels.length; i++) {
      if (assignedLabels[i] !== nextLabel) break;
      nextLabel++;
    }
  
    return nextLabel; // Return the next available button label
  };*/
  
  /*const handleOptionChange = async (buttonId, newValue) => {
    if (!newValue) return; // If no new value is selected, just return
    const currentWordItem = buttonPopovers[buttonId]?.selectedOption;

    // Find if the new word is already assigned to another button
    const oldButton = shapes
      .flatMap(shape => shape.buttons)
      .find(button => button.wordId === newValue._id);

    // If found, unassign it from the old button before assigning it to the new one
    if (oldButton) {
       // Find the shape that contains oldButton
      const oldShape = shapes.find(shape => shape.buttons.some(button => button._id === oldButton._id));
      const oldButtonShapeId = oldShape?._id;  // Ensure we extract `_id`

      if (oldButtonShapeId) {
        updateButton(oldButton._id, 'color', null);
      }

      await Promise.all([
          updateButton(oldButton._id, 'wordId', null),
          updateButton(oldButton._id, 'buttonLabel', null),
          updateButton(oldButton._id, 'color', null),
          updateWordList('', newValue._id, 'buttonId', 0),
      ]);
    }

    // If a different word is currently assigned, unassign it
    if (currentWordItem && currentWordItem._id !== newValue._id) {
      const shape = shapes.find(shape => shape._id === selectedItem.shapeId);
      const shapeColor = shape ? shape.color : '#d1d1d1'; // Default gray if no shape color found

      await Promise.all([
          updateWordList('', currentWordItem._id, 'buttonId', 0),
          updateButton(buttonId, 'wordId', null),
          updateButton(buttonId, 'buttonLabel', null),
          updateButton(buttonId, 'color', null),
      ]);
  }
  
    const nextLabel = calculateNextButtonLabel();
    const newColor = getRandomColor();

    await Promise.all([
      updateButton(buttonId, 'wordId', newValue._id),
      updateButton(buttonId, 'buttonLabel', nextLabel),
      updateButton(buttonId, 'color', newColor),
      updateWordList('', newValue._id, 'buttonId', buttonId),
      updateWordList('', newValue._id, 'color', newColor),
    ]);

    const updatedSelectedOption = wordList
      .flatMap(group => group.wordItems)
      .find(wordItem => wordItem._id === newValue._id);
  
    setButtonPopovers(prev => ({
      ...prev,
      [buttonId]: {
        ...prev[buttonId],
        selectedOption: updatedSelectedOption,
        inputValue: updatedSelectedOption ? updatedSelectedOption.text : '',
        open: false
      }
    }));

  };*/

  /*const handleAssignedWordTooltipVisibility = async (newVisibility) => {

    // Store the current visibility before making the optimistic update
    const currentVisibility = assignedWordTooltipVisibility;

    setAssignedWordTooltipVisibility(newVisibility);
  
    try {
      await axios.patch(`${baseURL}/api/soundboards/soundboard/${soundboardId}/updateTooltipVisibility`, {
        assignedWordTooltipVisibility: newVisibility
      });
    } catch (error) {

      // Revert to the previous visibility if the update fails
      setAssignedWordTooltipVisibility(currentVisibility);

      const extra = { 
        message: 'Failed to update tooltip visibility on the server',
        soundboardId,
        newVisibility
      };

      showNotification({
        notification: t('errors.snackbar.SoundboardShapeNotDeleted'),
        type: 'error',
        extra, 
        error,
        isException: true,
      });
    }
  };*/

  /*const unassignButton = async (shapeId, buttonIds) => {
    const ensureArray = (item) => Array.isArray(item) ? item : [item];    
    const validButtonIds = ensureArray(buttonIds); // Ensure buttonIds is an array

    try { 
      const responseWordList = await axios.patch(`${baseURL}/api/wordLists/wordList/${wordListId}/word/unassignButtonWordList`, { buttonIds: buttonIds });

      if (responseWordList.status === 200) {
        //ec await getWordList();
      } 
    } catch (error) {

      const extra = { 
        message: 'Error unassigning button in wordlist',
        wordListId,
        buttonIds
      };

      showNotification({
        notification: t('errors.snackbar.SoundboardButtonNotUnassigned'),
        type: 'error',
        extra, 
        error,
        isException: true,
      });
    }

    try {

      const responseSoundboard = await axios.patch(`${baseURL}/api/soundboards/soundboard/${soundboardId}/shape/${shapeId}/button/unassignButtonSoundboard`, { buttonIds: validButtonIds }); // Pass array of buttonIds

      if (responseSoundboard.status === 200) {
        // Trigger any additional actions needed on success
        //ec await getSoundboard();
      } 
    } catch (error) {

      const extra = { 
        message: 'Error unassigning button in soundboard',
        soundboardId,
        shapeId,
        buttonIds
      };
      
      showNotification({
        notification: t('errors.snackbar.SoundboardButtonNotUnassigned'),
        type: 'error',
        extra, 
        error,
        isException: true,
      });

    }
  };*/

/* Not used at all. Function to generate initial buttonPopvers from wordList
  function generateButtonPopoversFromWordList(wordList) {
    let states = {};
    wordList.forEach(group => {
      group.wordItems.forEach(wordItem => {
        if (wordItem.buttonId) {
          states[wordItem.buttonId] = {
            selectedOption: wordItem,
            inputValue: wordItem.text
          };
        }
      });
    });

    return states;
  }*/

/*useEffect(() => {
  // Save word list to session storage whenever it changes
  sessionStorage.setItem('wordList', JSON.stringify(wordList));
  sessionStorage.setItem('wordListId', JSON.stringify(wordListId));
  sessionStorage.setItem('shapes', JSON.stringify(shapes));
  sessionStorage.setItem('soundboardId', JSON.stringify(soundboardId));
}, [wordList, wordListId, shapes, soundboardId]);

useEffect(() => {
  // Save buttonPopovers to session storage whenever it changes
  sessionStorage.setItem('buttonPopovers', JSON.stringify(buttonPopovers));
}, [buttonPopovers]);*/

  return (
    <DataContext.Provider value={{ 
      //wordList, 
      //wordListId, 
      //setWordList, 
      //getWordList, 
      //setWordListId, 
      //updateWordList, 
      //updateWordListOnReorder,
      //addGroup,
      //addWordItem,
      //deleteGroup,
      //deleteWord,
      //shapes,
      //setShapes,
      //soundboardId,
      //setSoundboardId,
      //stageWidth, 
      //setStageWidth,
      //stageHeight,
      //setStageHeight,
      //wordListWidth,
      //setWordListWidth,
      //addShape,
      //updateShape, 
      //updateShapes,
      //handleOptionChange,
      //calculateNextButtonLabel,
      //,
      //colorOptions,
      //getSoundboard,
      //deleteShape,
      //assignedWordTooltipVisibility,
      //handleAssignedWordTooltipVisibility,
      //updateButton,
      //unassignButton,
      //buttonPopovers,
      //setButtonPopovers,
      //shapePopovers,
      //setShapePopovers,
      //selectedItem,
      //setSelectedItem
      }}>
      {children}
    </DataContext.Provider>
  );
};

export const useData = () => useContext(DataContext);
